import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import EventDetail from "@/pages/EventDetail";
import RingLogin from "@/pages/RingLogin";
import RingControl from "@/pages/RingControl";
import Monitor from "@/pages/Monitor";
import Judge from "@/pages/Judge";
import Billing from "@/pages/Billing";
import AdminPanel from "@/pages/AdminPanel";
import UserSettings from "@/pages/UserSettings";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentReturn";
import Invite from "@/pages/Invite";
import ServerMonitor from "@/pages/ServerMonitor";
import OfflineTokenGuard from "@/components/OfflineTokenGuard";
import MarketingLayout from "@/marketing/MarketingLayout";
import Home from "@/pages/marketing/Home";
import Features from "@/pages/marketing/Features";
import HowItWorks from "@/pages/marketing/HowItWorks";
import About from "@/pages/marketing/About";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
      <AuthProvider>
        <OfflineTokenGuard />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/about" element={<About />} />
          </Route>
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/events/:eventId" element={<ProtectedRoute><EventDetail /></ProtectedRoute>} />
          <Route path="/invite/:token" element={<ProtectedRoute><Invite /></ProtectedRoute>} />
          <Route path="/ring-login" element={<RingLogin />} />
          <Route path="/ring/:ringId/control" element={<RingControl />} />
          <Route path="/ring/:ringId/monitor" element={<Monitor />} />
          <Route path="/judge/:eventId/:ringId/:pwd" element={<Judge />} />
          <Route path="/judge/:eventId/:ringId" element={<Judge />} />
          <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><UserSettings /></ProtectedRoute>} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/server" element={<ServerMonitor />} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
